import { ScreenText } from '@/lang/ScreenText'
import ErrorModal from '@/popupcomponents/ErrorModal.vue'
import cart from '@/store/modules/checkout/cart/module'
import { Component, Mixins, Prop, PropSync, Vue } from 'vue-property-decorator'
import applicationStore from '@/store/modules/applications/applicationStore'
import { DuplicateApplicationErrorType } from '@/Model/application/types'
import Spinner from '@/commoncomponents/spinner/Spinner.vue'
import UIkit from 'uikit'
import APP_CONST from '@/constants/AppConst'
import AccountSettings from '@/mixins/accountSettings.mixin'
import commonEntry from '@/store/modules/commonEntry'

@Component({
  components: {
    Spinner,
    ErrorModal
  }
})
export default class AlreadySubmittedSite extends Mixins(AccountSettings) {
  @Prop() isScholarSelectionShowing!: boolean
  @PropSync('isVisible', { type: Boolean, required: true }) isVisibleSync!: boolean
  DuplicateApplicationErrorType = DuplicateApplicationErrorType
  applicationStore = applicationStore
  APP_CONST = APP_CONST

  public readonly screenText = new ScreenText()

  get removalInProgress(): boolean {
    return cart.isDeleting || cart.isUpdatingCart
  }

  get accentColor(): string {
    return commonEntry.accountDesignDetails.accentColor
  }

  changeParticipant() {
    this.$emit('changeParticipant')
  }

  removeApplication() {
    this.$emit('removeApplication')
  }

  mounted() {
    UIkit.util.on(this.$el, 'hidden', () => {
      this.$emit('closeModal')
    })
  }
}
